import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {OrderStateRangesActions} from '../store';
import {OrderStateRangesSelectors} from '../store/selectors';

@Injectable()
export class OrderStateRangesLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {
    return this.loadOrderStateRanges().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadOrderStateRanges(): Observable<boolean> {
    return this.store$.pipe(
      select(OrderStateRangesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store$.dispatch(OrderStateRangesActions.ReadOrderStateRanges());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
